import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ENTRYPOINT } from '@core/endpoint';
import { Pagination } from '@core/interface';

export const REPORTS_URL = `${ENTRYPOINT}reports/`;

export interface Report extends ReportRequest {
  id: number;
}

export type ReportRequest = Record<string, any>;

@Injectable({ providedIn: 'root' })
export class ReportService {
  private readonly http = inject(HttpClient);

  getByResourceId(
    reportType: string,
    ressourceId: number,
  ): Observable<Pagination<Report>> {
    return this.http.get<Pagination<Report>>(`${REPORTS_URL}${reportType}/`, {
      params: { resource: ressourceId },
    });
  }

  getReportByUrl(url: string): Observable<Record<string, any>> {
    const reportUrl = `${ENTRYPOINT.split('/api/')[0]}${url}`;
    return this.http.get<Record<string, any>>(reportUrl);
  }

  addReportToResource(value: ReportRequest): Observable<Report> {
    return this.http.post<Report>(`${REPORTS_URL}${value['type']}/`, value);
  }

  update(value: Report): Observable<Report> {
    return this.http.put<Report>(
      `${REPORTS_URL}${value['type']}/${value.id}/`,
      value,
    );
  }

  deleteReport(id: number): Observable<any> {
    return this.http.delete<any>(`${REPORTS_URL}${id}/`);
  }
}
